// extracted by mini-css-extract-plugin
module.exports = {"span":"ModalContent_span__3LdJl","container":"ModalContent_container__2XtuT"};